import { TRootState } from '@/store/store';

export const getVoucherPreviewImage = ({ voucherPreview }: TRootState) => voucherPreview.image;
export const getVoucherPreviewTitle = ({ voucherPreview }: TRootState) => voucherPreview.title;
export const isVoucherPreviewVisible = ({ voucherPreview }: TRootState) =>
  !!voucherPreview.title && !!voucherPreview.image;
